export default function WebsiteLayout() {
  return <div>WebsiteLayout</div>;
}
